import React from 'react';
import { connect } from 'react-redux';
import { Button, Modal } from 'react-bootstrap';
import ZoneDetail from '../../components/zone/ZoneDetail';

import { translate } from 'react-i18next';
import { defaultRejectHandler } from '../../utils/utility';
import { editZone } from '../../redux/zone/zone_actions';

class ZoneEditModal extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isValid: false,
      isDirty: false,
      isSubmittable: false,
    };

    this.zoneDetail = undefined;
  }

  onSaveHandler() {
    const editedZone = this.zoneDetail.getWrappedInstance().getWrappedInstance().getZoneData();
    this.props.editZone({ ...editedZone, id: this.props.zone.id });
  }

  render() {
    const { isEditing, errorMessage, editZone, zone, building, t, ...newProps } = this.props;
    const { isSubmittable } = this.state;
    return (
      <Modal
        {...newProps}
        bsSize="large"
        aria-labelledby="contained-modal-title-lg"
        backdrop="static"
      >
        <Modal.Header closeButton>
          <Modal.Title>{t('edit zone')}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <ZoneDetail
            zone={zone}
            building={building}
            ref={ref => (this.zoneDetail = ref)}
            onValid={isValid => this.setState({ isValid })}
            onDirty={isDirty => this.setState({ isDirty })}
            onSubmittable={isSubmittable => this.setState({ isSubmittable })}
            fieldErrors={errorMessage}
            onSubmit={() => !this.props.isEditing && !this.props.isEdited && this.onSaveHandler()}
          />
        </Modal.Body>
        <Modal.Footer>
          <Button
            id="zone-submit-edit"
            disabled={!isSubmittable || isEditing}
            onClick={() => this.onSaveHandler()}
          >
            {isEditing ? `${t('saving')}...` : t('save')}
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }
}

const mapStateToProps = state => ({
  isEditing: state.zone.isEditing,
  errorMessage: state.zone.errorMessage,
});

const mapDispatchToProps = dispatch => ({
  editZone: zone =>
    defaultRejectHandler(
      dispatch(editZone(zone.id, zone.name, zone.area, zone.floor_id, zone.description)),
    ),
});

export default translate('translations')(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  )(ZoneEditModal),
);



// WEBPACK FOOTER //
// ./src/modal/zone/ZoneEditModal.js